var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowIframe)?_c('div',{staticClass:"ifr"},[(!_vm.iframeUrl)?_c('div',{staticClass:"err-tips"},[_vm._v("链接错误,请联系管理员")]):_vm._e(),_c('iframe',{attrs:{"src":_vm.iframeUrl,"frameborder":"0"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }